// useMessagingHold — is this school's "candidate messages after application"
// pause on? (server: services/messagingHold.service.js)
//
// Until the server answers, and if it cannot, the screen assumes PAUSED: the
// server refuses held sends either way, and a screen that claimed messages
// were flowing when they were not would be the worse mistake.
import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export default function useMessagingHold() {
  const [state, setState] = useState({ loading: true, paused: true, history: [], stillSends: [], heldWhilePaused: [] });

  const reload = useCallback(async () => {
    try {
      const r = await api.get('/school-settings/messaging-hold');
      const d = r.data?.data || {};
      setState({
        loading: false,
        paused: d.paused !== false,
        history: d.history || [],
        stillSends: d.stillSends || [],
        heldWhilePaused: d.heldWhilePaused || [],
      });
    } catch (_) {
      setState((s) => ({ ...s, loading: false, paused: true }));
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { ...state, reload };
}

/* True when a server answer was the hold refusing (HTTP 423). */
export function isHeldError(err) {
  return err?.response?.status === 423 || err?.response?.data?.code === 'messaging_paused';
}
